import splitVoucherModalTemplate from '../views/modals/split-voucher-modal.tpl.html';
import createResidualVoucherModalTemplate from '../views/modals/create-residual-voucher-modal.tpl.html';
import voucherSingleMessageModalCreator
    from "../../../../modules/messages/helpers/voucher-single-message-modal-creator";

class VoucherDetailsCtrl {
    constructor(Alert, $stateParams, $http, $state, NavService, $uibModal, Acl, $translate, FileSaver, $injector) {
        this.alert = Alert;
        this.stateParams = $stateParams;
        this.api = $http;
        this.state = $state;
        this.navService = NavService;
        this.voucher = null;
        this.modal = $uibModal;
        this.acl = Acl;
        this.translate = $translate;
        this.fileSaver = FileSaver;
        this.injector = $injector;
        this.printInProgress = false;

        this.actionLogData = [];

        this.loadVoucher();
    }

    loadVoucher() {
        this.printInProgress = false;
        this.api.get(`vouchers/${this.stateParams.vid}`).then((response) => {
            this.voucher = response.data.data;
            this.loadActionLog();
            this.updateBreadcrumbParams();
        }, () => {
            const translatedValue = (path) => {
                return this.translate.instant(`vouchers.controllers.error_loading_voucher.${path}`);
            };

            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'failed',
                {
                    confirmButtonText: translatedValue('confirm'),
                    showCancelButton: false,
                    confirmButtonColor: '#e01249'
                }
            );

            this.state.go('app.vouchers.index');
        });
    }

    printVoucher() {
        if(this.printInProgress) {
            return;
        }

        this.printInProgress = true;
        this.api.post(`vouchers/${this.voucher.id}/print`).then(() => {
            this.alert.success('Success', 'Voucher print has been started');
            this.loadVoucher();
        }, () => {
            const translatedValue = (path) => {
                return this.translate.instant(`vouchers.controllers.error_printing_voucher.${path}`);
            };

            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'failed',
                {
                    confirmButtonText: translatedValue('confirm'),
                    showCancelButton: false,
                    confirmButtonColor: '#e01249'
                }
            );
        });
    }

    downloadVoucher() {
        this.api.get(`vouchers/${this.voucher.id}/download`, {responseType: "blob"})
            .then((response) => {
                console.log('download finished', response);
                const blob = new Blob([response.data], {type: response.headers('content-type')});
                console.log('blob created');
                this.fileSaver.saveAs(blob, 'voucher-' + this.voucher.number + '.pdf');
                console.log('save triggered');
            })
            .catch((e) => {
                this.alert.handle(e);
            });
    }

    sendVoucher() {
        voucherSingleMessageModalCreator(this.injector, this.voucher);
    }

    loadActionLog() {
        this.api.post(
            `fp/changelog/voucher/${this.stateParams.vid}`,
            {
                onlyArchived: false,
                filters: [],
                fields: [
                    "id",
                    "action",
                    "entity",
                    "timestamp",
                    "editor",
                    "entity_display_name",
                    "meta_data"
                ],
                sort: {
                    timestamp: "desc"
                },
                pagination: {
                    perPage: -1
                }
            }
        ).then((response) => {
            this.actionLogData = response.data.data
        })
    }

    cancelVoucher() {
        this.api.post(`vouchers/${this.voucher.id}/cancel`).then(() => {
            this.alert.success('Success', 'The voucher has been cancelled');
            this.loadVoucher();
        }, () => {
            const translatedValue = (path) => {
                return this.translate.instant(`vouchers.controllers.error_cancelling_voucher.${path}`);
            };

            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'failed',
                {
                    confirmButtonText: translatedValue('confirm'),
                    showCancelButton: false,
                    confirmButtonColor: '#e01249'
                }
            );
            this.loadVoucher();
        });
    }

    splitVoucher() {
        this.modal.open({
            controller: 'SplitVoucherModalController',
            controllerAs: 'vm',
            templateUrl: splitVoucherModalTemplate,
            size: 'lg',
            resolve: {
                voucherToSplit: () => {
                    return this.voucher;
                }
            }
        }).result.then((response) => {
            if (response.state) {
                this.alert.success('Success', 'Voucher has been split');
            } else {
                const translatedValue = (path) => {
                    return this.translate.instant(`vouchers.controllers.error_splitting_voucher.${path}`);
                };

                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            }
            this.loadVoucher();
        }, () => {
            this.loadVoucher();
        })
    }

    createResidualVoucher() {
        this.modal.open({
            controller: 'CreateResidualVoucherModalController',
            controllerAs: 'vm',
            templateUrl: createResidualVoucherModalTemplate,
            size: 'sm',
            resolve: {
                voucherToCreateResidualFor: () => {
                    return this.voucher;
                }
            }
        }).result.then((response) => {
            if (response.state) {
                this.alert.success('Success', 'Residual voucher has been created');
            } else {
                const translatedValue = (path) => {
                    return this.translate.instant(`vouchers.controllers.error_residual_voucher.${path}`);
                };

                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            }
            this.loadVoucher();
        }, () => {
            this.loadVoucher();
        })
    }

    goToVoucherDetails(voucher) {
        this.state.go('app.vouchers.main.details', {vid: voucher.id});
    }

    updateBreadcrumbParams() {
        let customActions = [];

        if (this.voucher.printable && this.acl.hasRight('vouchers::print-vouchers')) {
            customActions.push({
                label: 'Print',
                action: () => {
                    this.printVoucher();
                },
                icon: 'print',
                order: 5
            });
        }

        if (this.voucher.downloadable && this.acl.hasRight('vouchers::download-vouchers')) {
            customActions.push({
                label: 'Download',
                action: () => {
                    this.downloadVoucher();
                },
                icon: 'download',
                order: 6
            });
        }

        if (this.voucher.sendable && this.acl.hasRight('vouchers::send-vouchers')) {
            customActions.push({
                label: 'Send by Mail',
                action: () => {
                    this.sendVoucher();
                },
                icon: 'envelope',
                order: 7
            });
        }

        if (this.voucher.splittable && this.acl.hasRight('vouchers::split-vouchers')) {
            customActions.push({
                label: 'Split',
                action: () => {
                    this.splitVoucher();
                },
                icon: 'sitemap',
                order: 10
            });
        }

        if (this.voucher.cancelable && this.acl.hasRight('vouchers::cancel-vouchers')) {
            customActions.push({
                label: 'Cancel',
                action: () => {
                    this.cancelVoucher();
                },
                icon: 'times-circle',
                order: 15
            });
        }

        if (this.voucher.residual_allowed && this.acl.hasRight('vouchers::create-residual')) {
            customActions.push({
                label: 'Create Residual',
                action: () => {
                    this.createResidualVoucher();
                },
                icon: 'plus-circle',
                order: 20
            });
        }

        this.navService.overrideMainSideNavActions(customActions);

        this.navService.setBreadcrumbParameters({
            number: this.voucher ? this.voucher.number : '',
            template_title: this.voucher ? this.voucher.template.title : ''
        });
    }
}

VoucherDetailsCtrl.$inject = [
    'Alert',
    '$stateParams',
    '$http',
    '$state',
    'NavService',
    '$uibModal',
    'Acl',
    '$translate',
    'FileSaver',
    '$injector'
];


angular
    .module('festzelt-os.vouchers.main')
    .controller('VoucherDetailsCtrl', VoucherDetailsCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/controllers/details-controller.js